import { styled } from 'styled-components'

export const FeedbackPageViewContainer = styled.div`
  display: flex;
  height: 100vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
